import { LoginCredentials, RegisterCredentials, User, ResetPasswordCredentials } from '../types/auth.types';
import axiosInstance, { publicAxiosInstance } from '../../utils/axios';

export const authService = {
  async login(credentials: LoginCredentials): Promise<{ access_token: string }> {
    const response = await publicAxiosInstance.post('/api/v1/auth/login', credentials);
    return response.data;
  },

  async register(credentials: RegisterCredentials): Promise<{ access_token: string }> {
    try {
      const response = await publicAxiosInstance.post('/api/v1/auth/register', credentials);
      return response.data;
    } catch (error: any) {
      // If the error has a response, throw the response data
      if (error.response?.data) {
        throw error.response.data;
      }
      // Otherwise throw the original error
      throw error;
    }
  },

  async validateToken(): Promise<User> {
    const response = await axiosInstance.get('/api/v1/users/me');
    return response.data;
  },

  setToken(token: string) {
    localStorage.setItem('token', token);
    // Token will be automatically added by axios interceptor
  },

  clearToken() {
    localStorage.removeItem('token');
    // Token will be automatically removed when cleared from localStorage
  },

  getToken() {
    return localStorage.getItem('token');
  },

  async forgotPassword(username: string): Promise<void> {
    await publicAxiosInstance.post(`/api/v1/users/forgot-password/${username}`);
  },

  async resetPassword(credentials: ResetPasswordCredentials): Promise<void> {
    await publicAxiosInstance.post('/api/v1/users/reset-password', {
      code: credentials.code,
      newPassword: credentials.newPassword,
      confirmPassword: credentials.confirmPassword
    });
  }
};
